export default __webpack_public_path__ + "static/media/user-outlined.415d2405.svg";